import { Component } from 'react';
import { connect } from 'react-redux';
import ThemeSettingsContainer from './ThemeSettingsContainer';
import { getHasAccess } from '../selectors/authSelectors';
import { getPreviewCacheBust } from '../selectors/appSelectors';
import * as ThemeSettingsActions from '../actions/ThemeSettingsActions';
import * as ModalActions from '../actions/ModalActions';
import * as ThemeDependentAssetsActions from '../actions/ThemeConnectionsActions';
import { getThemeName, getThemePath, getThemeImageUrl } from '../selectors/themeSelectors';
import EPDependentsList from 'editor-components/modals/dependents/EPDependentsList';
import EPDependentsItem from 'editor-components/modals/dependents/EPDependentsItem';
import { getDependentTemplatesRequestStatus, getGroupedDependentAssetOptions, getGroupedDependentAssetOptionsCount } from '../selectors/themeDependentAssetsSelectors';
import { getThemeSettingsLastSave, getThemeSettingsValues } from '../selectors/themeSettingsSelectors';
import { getIsUniversalThemeEditing } from '../utils/themes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    hasAccess: getHasAccess(state),
    previewCacheBust: getPreviewCacheBust(state),
    themePath: getThemePath(state),
    dependentAssetOptionGroups: getGroupedDependentAssetOptions(state),
    dependentsCount: getGroupedDependentAssetOptionsCount(state),
    dependentTemplatesRequestStatus: getDependentTemplatesRequestStatus(state),
    themeName: getThemeName(state),
    imageUrl: getThemeImageUrl(state),
    lastSave: getThemeSettingsLastSave(state),
    themeSettingsValues: getThemeSettingsValues(state)
  };
};
const mapDispatchToProps = {
  fetchThemeAndSettings: ThemeSettingsActions.fetchThemeAndSettings,
  fetchHasBufferedSettingsChanges: ThemeSettingsActions.fetchHasBufferedSettingsChanges,
  openPatagoniaOnboardingModal: ModalActions.openPatagoniaOnboardingModal,
  saveSettingsBuffer: ThemeSettingsActions.saveSettingsBuffer,
  fetchDependentPages: ThemeDependentAssetsActions.fetchDependentPages,
  fetchDependentTemplates: ThemeDependentAssetsActions.fetchDependentTemplates
};
class UniversalEditorContainer extends Component {
  //TODO type all props when complete
  constructor(props) {
    super(props);
    this.toggleDependentsPanel = () => {
      this.setState({
        showDependentsPanel: !this.state.showDependentsPanel
      });
    };
    this.clearScrollToThemePath = () => {
      return null;
    };
    this.previewIframeElement = null;
    this.previewIframeWrapperElement = null;
    this.state = {
      showDependentsPanel: false
    };
  }
  componentDidMount() {
    const {
      themePath,
      fetchDependentPages,
      fetchDependentTemplates
    } = this.props;
    if (themePath) {
      fetchDependentPages();
      fetchDependentTemplates();
    }
  }
  renderDependentItems(dependents, linksDisabled) {
    return dependents.map(dependent => {
      const {
        link,
        text,
        value
      } = dependent;
      return /*#__PURE__*/_jsx(EPDependentsItem, {
        linkDisabled: linksDisabled,
        link: link,
        children: text
      }, value);
    });
  }
  renderDependentsList() {
    const {
      dependentAssetOptionGroups
    } = this.props;
    return dependentAssetOptionGroups.map(dependentsGroup => {
      const {
        disabledMessage,
        disableLinks,
        options,
        text
      } = dependentsGroup;
      if (!options.length) return null;
      return /*#__PURE__*/_jsx(EPDependentsList, {
        disabledMessage: disabledMessage,
        disableLinks: disableLinks,
        title: text,
        children: this.renderDependentItems(options, disableLinks)
      }, text);
    });
  }
  renderDependentsPanel() {
    const {
      showDependentsPanel
    } = this.state;
    const {
      dependentsCount,
      AsyncComponentContext,
      themeName,
      themePath,
      templatePath,
      imageUrl,
      lastSave
    } = this.props;
    if (!showDependentsPanel) return null;
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        EPDependentsPanel
      }) => EPDependentsPanel && /*#__PURE__*/_jsx(EPDependentsPanel, {
        themeName: themeName,
        imageUrl: imageUrl,
        themePath: themePath,
        templatePath: templatePath,
        onClose: this.toggleDependentsPanel,
        totalDependents: dependentsCount,
        lastSave: lastSave,
        children: this.renderDependentsList()
      })
    });
  }
  render() {
    const {
      trackUpdateThemeSettings,
      trackInteraction,
      trackUndoRedoInteraction,
      AsyncComponentContext,
      hasAccess,
      fromAppName,
      handleSaveThemeSettingsBuffer,
      reloadIframePreview,
      handleSetIsUniversalThemeSavedAndApplied,
      isUniversalThemeSavedAndApplied
    } = this.props;
    const isUniversalThemeEditing = getIsUniversalThemeEditing(fromAppName);
    return /*#__PURE__*/_jsxs("div", {
      style: {
        height: '100%'
      },
      children: [this.renderDependentsPanel(), /*#__PURE__*/_jsx(ThemeSettingsContainer, {
        clearScrollToThemePath: this.clearScrollToThemePath,
        scrollToThemeField: undefined,
        AsyncComponentContext: AsyncComponentContext,
        trackUpdateThemeSettings: trackUpdateThemeSettings,
        trackInteraction: trackInteraction,
        trackUndoRedoInteraction: trackUndoRedoInteraction,
        fromAppName: fromAppName,
        toggleDependentsPanel: this.toggleDependentsPanel,
        hasThemeEditAccess: hasAccess,
        handleSaveThemeSettingsBuffer: handleSaveThemeSettingsBuffer,
        isUniversalThemeEditing: Boolean(isUniversalThemeEditing),
        reloadScalableEditorIframePreview: reloadIframePreview,
        handleSetIsUniversalThemeSavedAndApplied: handleSetIsUniversalThemeSavedAndApplied,
        isUniversalThemeSaved: isUniversalThemeSavedAndApplied
      })]
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(UniversalEditorContainer);